export default __webpack_public_path__ + "static/media/5.d2fcf66b.JPG";